export default "__VITE_ASSET__Cpff1h_6__"